<template>
  <div>
    <p v-html="translation('new_termini')"></p>
  </div>
</template>

<script>
import translationStore from '@/store/translations'

export default {
  name: 'PrivacyView', // Nome componente più specifico
  data () {
    return {
      translationStore: translationStore
    }
  },
  methods: {

  },

  computed: {
    translation () {
      return translationStore.getters.traduzione
    }
  }

}
</script>

<style scoped>
/*
 * Ho usato <style scoped> per isolare questi stili al componente.
 * Se hai bisogno di stili globali (come per la griglia row/col), usa <style> non scoped.
 * Gli stili qui sotto sono locali e specifici per i contenuti della privacy.
 */

.content-container {
  padding: 20px;
  line-height: 1.6;
  color: #333;
  /* Testo leggibile */
}

/* Formattazione Titoli */
h1 {
  font-size: 2.5em;
  color: #1a1a1a;
  margin-top: 0;
  margin-bottom: 20px;
  border-bottom: 2px solid #ddd;
  padding-bottom: 10px;
}

h2 {
  font-size: 1.8em;
  color: #444;
  margin-top: 30px;
  margin-bottom: 15px;
}

.intro-paragraph {
  font-size: 1.1em;
  font-weight: 500;
  margin-bottom: 20px;
}

/* Stile per le liste (UL) */
.styled-list {
  list-style-type: disc;
  /* Assicura i puntini */
  margin-left: 20px;
  /* Indentazione per staccare i puntini dal bordo */
  padding-left: 0;
  margin-bottom: 20px;
}

.styled-list li {
  margin-bottom: 8px;
  padding-left: 5px;
  /* Spazio tra il puntino e il testo */
}

/* Stili esistenti (se provengono da un file globale o libreria, potresti non averne bisogno qui) */
/* h1.style.color-black {
  color: black !important;
  font-size: 2em;
} */
/* .questions {
  width: 100%;
  border-bottom: 1px solid #d5d5d5;
} */
</style>
